module.exports = __webpack_public_path__ + "img/Info_tall.1776318f.jpg";